<div class="content">
  <div class="row mx-0">
    <div class="col-4 px-0 text-start">
      <h3>Capture Queue</h3>
    </div>

    <div class="col-8 px-0 text-end capture-advancement-queue-count-container">
      <span>
        Capture Advancements In Progress:
        <span class="capture-advancement-queue-count">
          @if (advancementQueueCount !== null) {
            {{ advancementQueueCount | number }}
          }
          @if (advancementQueueCount === null) {
            -
          }
        </span>
      </span>
    </div>
  </div>

  <app-capture-queue-settings
    [disableSearch]="loadingResults"
    (performSearch)="onPerformSearch()"
    (performReset)="onPerformReset()" />

  @if (!loadingResults) {
    <div class="mt-2">
      @if (captureQueueResults.length > 0) {
        <div>
          <app-capture-queue-results [captureQueueResults]="captureQueueResults" />
          @if (hasMoreResults) {
            <div class="text-center mb-4">
              <a href="#next" (click)="onNextClick($event)" class="load-next-captures">
                View Next {{ limit }} Captures
              </a>
            </div>
          }
        </div>
      } @else {
        @if (error) {
          <div>
            <p class="mt-2 ms-1">{{ error }}</p>
          </div>
        }
      }
    </div>
  } @else {
    <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
  }
</div>
